import { useStore } from "@nanostores/preact";
import { $panel, $toast } from "../state/stores";
import { AssetHistoryPanel } from "./AssetHistoryPanel";
import { InspectorPanel } from "./InspectorPanel";
import { InventoryPanel } from "./InventoryPanel";
import { LoginPanel } from "./LoginPanel";
import { MenuPanel } from "./MenuPanel";
import { PlacePropsPanel } from "./PlacePropsPanel";
import { PlotPanel } from "./PlotPanel";
import { PolicyPanel } from "./PolicyPanel";
import { PublicAssetsPanel } from "./PublicAssetsPanel";
import { SettingsPanel } from "./SettingsPanel";
import { MailPanel } from "./MailPanel";
import { MarkerPanel } from "./MarkerPanel";
import { TransferPanel } from "./TransferPanel";
import { UploadPanel } from "./UploadPanel";

export function App() {
  const panel = useStore($panel);
  const toastMsg = useStore($toast);
  return (
    <>
      {panel === "login" && <LoginPanel />}
      {panel === "menu" && <MenuPanel />}
      {panel === "upload" && <UploadPanel />}
      {panel === "inventory" && <InventoryPanel />}
      {panel === "transfer" && <TransferPanel />}
      {panel === "plot" && <PlotPanel />}
      {panel === "policy" && <PolicyPanel />}
      {panel === "public" && <PublicAssetsPanel />}
      {panel === "placeprops" && <PlacePropsPanel />}
      {panel === "history" && <AssetHistoryPanel />}
      {panel === "settings" && <SettingsPanel />}
      {panel === "marker" && <MarkerPanel />}
      {panel === "mail" && <MailPanel />}
      {panel === "inspector" && <InspectorPanel />}
      {toastMsg && <div class="panel toast" style="top:auto;bottom:80px;min-width:0;padding:8px 14px">{toastMsg}</div>}
    </>
  );
}
